export const ZONE = 'Europe/Zurich';
